import { extendTheme } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme'

const theme = {
    baseStyle: {
        fontWeight: 'normal',
    },
    variants: {
        rounded: {
            tab: {
                fontWeight: 'semibold',
                px: '3em',
                color: 'teal.600',
                borderBottom: "1px solid",
                borderBottomColor: 'teal.600',
                whiteSpace: "nowrap",
                _selected: {
                    color: 'teal.300',
                    boxShadow: 'none',
                    borderBottom: "1px solid",
                    borderBottomColor: 'teal.300'
                },

            }
        },
    },
    defaultProps: {
        colorSheme:'teal',
        variant: 'rounded',
    }
};

export default theme;